export const DateFilterOption = {
  Today: 'today',
  OneDayAgo: 'one-day-ago',
  TwoDaysAgo: 'two-days-ago',
  ThreeDaysAgo: 'three-days-ago',
  Period: 'period',
} as const;

export type SetDateFilterOptions =
  | {
      newDate:
        | typeof DateFilterOption.Today
        | typeof DateFilterOption.OneDayAgo
        | typeof DateFilterOption.TwoDaysAgo
        | typeof DateFilterOption.ThreeDaysAgo;
      from: string;
      until: string;
    }
  | {
      newDate: typeof DateFilterOption.Period;
      from: string;
      until: string;
    };
